import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Page error:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center px-5 bg-[#0a0a0a]" data-testid="error-boundary">
          <div className="max-w-md text-center">
            <h1 className="font-display text-3xl font-black tracking-tight text-white">Something went wrong on this page.</h1>
            <p className="mt-3 text-regera-dim text-sm">Please reload the page. If the problem continues, return to the home page.</p>
            <div className="mt-8 flex justify-center gap-4">
              <button
                type="button"
                onClick={() => window.location.reload()}
                className="bg-[#e60000] text-white px-6 py-3 text-sm tracking-[0.14em] uppercase font-medium hover:bg-[#990000] transition-colors"
              >
                Reload
              </button>
              <a href="/" className="border border-white/20 text-white px-6 py-3 text-sm tracking-[0.14em] uppercase font-medium hover:border-white/50 transition-colors">
                Home
              </a>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
